
import React, { useEffect } from 'react';
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

const MeineVision = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data: images } = useQuery({
    queryKey: ["images", "meine-vision"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "meine-vision" as any)
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data;
    },
  });

  const getBackgroundImage = () => {
    if (images && images.length > 0) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(images[0].storage_path);
      return data.publicUrl;
    }
    return null;
  };

  const handleNavigateBack = () => {
    const section = document.getElementById('ns3');
    if (section) {
      const offset = -80;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const imageUrl = getBackgroundImage();

  return (
    <div className="bg-gradient-to-r from-[#243949] to-[#517fa4]" id="vision">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <Button 
            variant="ghost" 
            className="text-white hover:bg-white/10 p-2 h-auto group"
            onClick={handleNavigateBack}
          >
            <div className="flex items-center animate-horizontal-bounce">
              <ChevronLeft className="w-4 h-4" />
              <ChevronLeft className="w-4 h-4 -ml-2" />
            </div>
          </Button>
          
          <h2 className="text-xl md:text-2xl text-white font-bold text-center uppercase flex-grow">
            Weil eure Geschichte zählt.
          </h2>
          
          <div className="w-[40px]"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Image section */}
          <div className="flex flex-col items-center">
            <div className="w-full max-w-xl mb-8">
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                <div className="relative aspect-[16/9] w-full rounded-lg overflow-hidden">
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="Weil eure Geschichte zählt"
                      className="w-full h-full object-cover rounded-lg"
                    />
                  ) : (
                    <div className="w-full h-full bg-white/20 flex items-center justify-center rounded-lg">
                      <p className="text-white/60 text-center">Bild im Admin-Bereich hochladen</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* First text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Ich habe als Pfarrer dutzende Paare getraut – und jedes Mal war es ein Privileg, ihre Geschichte zu erzählen.
            </p>
          </div>

          {/* Second text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Die leuchtenden Augen. Die Tränen der Rührung. Die Gäste, die sagten: <strong>"Das war die schönste Trauung, die ich je erlebt habe."</strong>
            </p>
          </div>

          {/* Third text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Heute bin ich kein Pfarrer mehr. Aber meine Leidenschaft für diesen besonderen Moment ist geblieben. Ohne Predigt – mit Herz.
            </p>
          </div>

          {/* Fourth text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-8">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              <strong>Eure Geschichte verdient es, erzählt zu werden.</strong>
            </p>
          </div>

          <div className="flex justify-center mt-8">
            <Button 
              variant="ghost" 
              className="text-white hover:bg-white/10 p-2 h-auto group"
              onClick={handleNavigateBack}
            >
              <div className="flex items-center animate-horizontal-bounce">
                <ChevronLeft className="w-4 h-4" />
                <ChevronLeft className="w-4 h-4 -ml-2" />
              </div>
              <span className="ml-2">Zurück</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeineVision;
